import { Typography, Link } from '@mui/material';
import React from 'react';
import theme from '../../../theme/theme';
import CustomAccordion from '../../shared/CustomAccordion.styled';
import styles from '../styles';

const SubDropdownMobile = ({ nav, handleExpand }) =>
  nav?.PrimaryNavL2?.map(link => (
    <CustomAccordion
      styles={styles.subCollapseContainer}
      title={link.title}
      description={<MobileNavList nav={link?.PrimaryNavL3} handleExpand={handleExpand} />}
    />
  ));

export default SubDropdownMobile;

const MobileNavList = ({ nav, handleExpand }) =>
  nav?.map(level3 =>
    level3?.Link?.map((data, i) => (
      <Link
        key={i}
        href={data?.link}
        aria-label={data.ariaLabel}
        underline='none'
        onClick={handleExpand}
        onKeyDown={e => {
          if (e.key === ' ') {
            e.preventDefault();
            handleExpand();
            e.currentTarget.click();
          }
        }}
      >
        <Typography
          variant='body1'
          sx={{
            color: theme.palette.primary.headerText,
            p: 1,
          }}
        >
          {data?.title}
        </Typography>
      </Link>
    ))
  );
